const FriendshipStatus = Object.freeze({
    PENDING: "PENDING",
    ACCEPTED: "ACCEPTED",
    DECLINED: "DECLINED",
});

export default FriendshipStatus;
